/**
 * TreatmentExportSidebar — options for the single-treatment PDF export.
 * Shared groups (letterhead, patient, signature, fields) come from
 * components/pdfExport/PdfExportControls.js; this file adds the content
 * toggles (tags / version / hide empty answers) and the free texts.
 */

import {
  Group,
  ToggleRow,
  TextField,
  SignatureSegment,
  LetterheadToggles,
  PatientToggles,
} from "../../pdfExport/PdfExportControls";
import { TEXT_LIMITS } from "../../pdfExport/pdfExportOptions";

function TreatmentExportSidebar({
  options,
  setOption,
  toggleOption,
  setText,
  clinic,
  patient,
  typeName,
  hasTags,
  hasVersion,
  hasLicense,
  isAdmin,
  savedSignatureUrl,
  onDrawSignature,
  defaultTitle,
}) {
  const c = options.content;

  return (
    <div className="pdx-sidebar">
      <Group title="מסמך">
        <TextField
          id="tex-title"
          label="כותרת המסמך"
          value={options.title}
          onChange={(v) => setText("title", v)}
          max={TEXT_LIMITS.title}
          placeholder={defaultTitle}
        />
        <TextField
          id="tex-addressee"
          label="לכבוד (נמען)"
          value={options.addressee}
          onChange={(v) => setText("addressee", v)}
          max={TEXT_LIMITS.addressee}
          placeholder="לדוגמה: קופת חולים כללית / בית ספר"
        />
      </Group>

      <LetterheadToggles
        header={options.header}
        onToggle={(key) => toggleOption("header", key)}
        clinic={clinic}
        hasLicense={hasLicense}
        isAdmin={isAdmin}
      />

      <PatientToggles
        patient={options.patient}
        onToggle={(key) => toggleOption("patient", key)}
        patientDoc={patient}
        typeName={typeName}
      />

      <Group title="תוכן">
        <div className="pdx-toggle-list">
          <ToggleRow
            label="תגיות"
            checked={c.tags}
            disabled={!hasTags}
            hint={!hasTags ? "אין תגיות לתיעוד זה" : null}
            onChange={() => toggleOption("content", "tags")}
          />
          <ToggleRow
            label="מספר גרסה"
            checked={c.version}
            disabled={!hasVersion}
            hint={!hasVersion ? "גרסה ראשונה — לא יוצג" : null}
            onChange={() => toggleOption("content", "version")}
          />
          <ToggleRow
            label="הסתרת שאלות ללא תשובה"
            checked={c.hideEmptyAnswers}
            onChange={() => toggleOption("content", "hideEmptyAnswers")}
          />
        </div>
      </Group>

      <Group title="חתימה">
        <SignatureSegment
          value={options.signature}
          onChange={(v) => setOption(null, "signature", v)}
          savedSignatureUrl={savedSignatureUrl}
          onDrawSignature={onDrawSignature}
        />
      </Group>

      <Group title="טקסטים נוספים">
        <TextField
          id="tex-reco"
          label="המלצות / סיכום חופשי"
          value={options.recommendations}
          onChange={(v) => setText("recommendations", v)}
          max={TEXT_LIMITS.recommendations}
          multiline
          rows={4}
          placeholder="יופיע כפסקה לפני החתימה"
        />
        <TextField
          id="tex-footer"
          label="הערות והסתייגויות לתחתית הדוח"
          value={options.footerNote}
          onChange={(v) => setText("footerNote", v)}
          max={TEXT_LIMITS.footerNote}
          multiline
          rows={3}
          placeholder="לדוגמה: הדוח מבוסס על תצפית בפגישה אחת ואינו מהווה אבחנה"
        />
      </Group>
    </div>
  );
}

export default TreatmentExportSidebar;
